<template>
  <v-dialog
    v-model="open"
    max-width="290"
    transition="dialog-bottom-transition"
    persistent
  >
    <v-card>
      <v-card-title class="text-h5 justify-center">
        Confirm Deletion
      </v-card-title>
      <v-card-text class="text-center">
        Are you sure you want to delete this list?
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn color="secondary" text @click="$emit('close', false)">
          Cancel
        </v-btn>
        <v-btn color="secondary" raised @click="$emit('close', true)">
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      required: true,
    },
  },
}
</script>

<style></style>
